var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-slide",style:({
        backgroundImage: ("url(" + _vm.src + ")"),
        paddingBottom: _vm.ratio ? ((1/_vm.ratio * 100) + "%") : '', 
        height: _vm.height ? typeof _vm.height === 'number' ? (_vm.height + "px") : _vm.height : '',
        width: _vm.width ? typeof _vm.width === 'number' ? (_vm.width + "px") : _vm.width : '',
    })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }